// extracted by mini-css-extract-plugin
module.exports = {"a-star__icon":"Star_a-star__icon__Pks0t","a-star":"Star_a-star__BD0Qh","-size-sm":"Star_-size-sm__XG8sh","-size-lg":"Star_-size-lg__OGHOL"};